// Custom play button over a <video>: hides while playing, comes back when the video is paused or has ended.
// The native controls only show while the video plays, so the button is the one way to start it.
export const initVideoPlay = (video, button, poster = null) => {
    if (!video || !button) return;

    const showCover = (visible) => {
        button.hidden = !visible;
        video.controls = !visible;
        if (poster) poster.hidden = !visible;
    };

    showCover(true);

    button.addEventListener("click", () => {
        showCover(false);
        video.focus();
        video.play()?.catch(() => showCover(true));
    });

    // Scrubbing can pause for a moment; the end has its own handler.
    video.addEventListener("pause", () => {
        if (video.seeking || video.ended) return;
        showCover(true);
        button.focus({ preventScroll: true });
    });

    video.addEventListener("ended", () => {
        video.currentTime = 0;
        showCover(true);
    });
};
